var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F4F4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4042_19631",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#5A81FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4042_19631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 29.0717V20.395L10.6667 15.9933V24.67L18.6667 29.0717ZM21.3333 29.0717L29.3333 24.67V15.9933L21.3333 20.395V29.0717ZM20 18.21L27.9 13.8717L20 9.53333L12.1 13.8717L20 18.21ZM9.33333 26.8867C8.91111 26.6544 8.58333 26.3483 8.35 25.9683C8.11667 25.5883 8 25.1661 8 24.7017V14.6317C8 14.1672 8.11667 13.745 8.35 13.365C8.58333 12.985 8.91111 12.6789 9.33333 12.4467L18.6667 7.34833C19.0889 7.11611 19.5333 7 20 7C20.4667 7 20.9111 7.11611 21.3333 7.34833L30.6667 12.4467C31.0889 12.6789 31.4167 12.985 31.65 13.365C31.8833 13.745 32 14.1672 32 14.6317V24.7017C32 25.1661 31.8833 25.5883 31.65 25.9683C31.4167 26.3483 31.0889 26.6544 30.6667 26.8867L21.3333 31.985C20.9111 32.2172 20.4667 32.3333 20 32.3333C19.5333 32.3333 19.0889 32.2172 18.6667 31.985L9.33333 26.8867Z",
    fill: "#5A81FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.353f0c548a4bd6f7ffed86943f72022e.svg";
export { ForwardRef as ReactComponent };